import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-semibold ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-glow",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-border bg-transparent text-foreground hover:bg-muted/80 hover:border-primary/60",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-muted hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        hero: "border border-white/15 bg-[linear-gradient(135deg,hsl(var(--primary)),hsl(var(--accent))_55%,hsl(220_10%_40%))] text-primary-foreground font-bold shadow-[0_12px_36px_rgba(0,0,0,0.45)] hover:-translate-y-0.5 hover:shadow-[0_18px_42px_rgba(0,0,0,0.55)] active:translate-y-0",
        heroOutline: "border-2 border-primary/40 bg-[linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))] text-foreground backdrop-blur-sm hover:bg-primary/10 hover:border-primary/70 hover:shadow-glow",
        glow: "bg-primary text-primary-foreground shadow-glow hover:shadow-[0_0_26px_hsl(var(--primary)/0.22)] transition-shadow",
        accent: "bg-accent text-accent-foreground hover:bg-accent/90 hover:shadow-[0_0_28px_hsl(var(--accent)/0.25)]",
        glass: "bg-card/70 backdrop-blur-xl border border-white/10 text-foreground hover:bg-card/90 hover:border-white/20",
      },
      size: {
        default: "h-11 px-5 py-2",
        sm: "h-9 rounded-lg px-4 text-xs",
        lg: "h-12 rounded-xl px-8 text-base",
        xl: "h-14 rounded-2xl px-10 text-lg",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
